var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgCry(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,64) scale(0.1,-0.1)",
    fill: "#003C71"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255 601 c-88 -24 -159 -82 -196 -159 -32 -66 -32 -178 0 -244 27 -55 93 -120 148 -144 51 -23 175 -23 226 0 55 24 121 89 148 144 32 66 32 178 0 244 -27 55 -94 121 -147 143 -46 19 -138 27 -179 16z m184 -42 c201 -101 201 -377 0 -478 -85 -43 -153 -43 -238 0 -201 101 -201 377 0 478 85 43 153 43 238 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 366 c-27 -33 18 -72 48 -42 13 13 14 20 6 34 -15 23 -38 26 -54 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420 366 c-27 -33 18 -72 48 -42 13 13 14 20 6 34 -15 23 -38 26 -54 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265 215 c-31 -16 -55 -42 -55 -58 0 -5 16 5 37 23 33 29 41 32 85 28 49 -5 66 5 26 16 -37 9 -61 7 -93 -9z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCry);
export default __webpack_public_path__ + "static/media/cry.d1adb2a8de4b88b418448912a008231f.svg";
export { ForwardRef as ReactComponent };